module.exports = __webpack_public_path__ + "img/departments.ce72fed0.png";